<template>
  <el-dialog
    title="修改密码"
    :visible.sync="dialogVisible"
    width="450px"
    :before-close="handleClose">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-form-item label="原密码:" prop="password">
        <el-input v-model="ruleForm.password" />
      </el-form-item>
      <el-form-item label="新密码:" prop="new_password">
        <el-input v-model="ruleForm.new_password" />
      </el-form-item>
      <el-form-item label="密码确认:" prop="new_password_1">
        <el-input v-model="ruleForm.new_password_1" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updatePasswordApi } from '@/api/mine'
export default {
  //
  name: '',
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: true,
      ruleForm: {
        password: '',
        new_password: '',
        new_password_1: ''
      },
      rules: {
        password: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        new_password_1: [
          { required: true, message: '请确认密码', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.$emit('close')
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { password, new_password, new_password_1 } = this.ruleForm
          if (password === new_password) {
            this.$message.error('新/老密码一致,请修改后重试')
            return
          } else if (new_password !== new_password_1) {
            this.$message.error('确认密码错误,请修改后重试')
          } else {
            updatePasswordApi(this.ruleForm).then((res) => {
              this.$message.success('密码修改成功')
              this.dialogVisible = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box{}
</style>
